import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

// import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
// import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// import TimePicker from '@material-ui/lab/TimePicker';

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
    FormGrid,
    FormAction
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { AssignmentInputButtonContainer } from '../../../styles/assignment/assignment'
import { Textarea } from '../../../components/textarea/textarea'
import { SelectInput } from '../../../components/select/select';
import { Hr } from '../../../styles/dashboard';

//Registration schema
const schema = yup.object().shape({
    subject: yup.string().required("Subject is a required field"),
    description: yup.string().required("Description is a required field"),
});

const ExaminationCreate = () => {

    const [imageUploadValue, setImageUploadValue] = useState('')

    const {
        handleSubmit,
        register,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container style={{ maxWidth: '859px' }}>
                    <MainContent>
                        <Heading>
                            Create Exam
                        </Heading>
                        <Breadcrumb
                            crumbs={['Examination', "Create"]}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormGrid>
                                <div>
                                    <InputWrapper>
                                        <Input
                                            id="examName"
                                            label="EXAM NAME"
                                            type="text"
                                            placeholder="Mathematics"
                                            fullWidth
                                        />
                                    </InputWrapper>
                                    <InputWrapper>
                                        <Textarea
                                            id="examInstructions"
                                            label="EXAM INSTRUCTIONS"
                                            type="text"
                                            placeholder="Hello World!"
                                            fullWidth
                                        />
                                    </InputWrapper>
                                    {/* TODO: DATE AND TIME PICKER */}
                                    {/* <InputWrapper className="grid-2-2">
                                <Input
                                    id="mobileNumber"
                                    label="Mobile Number"
                                    type="text"
                                    placeholder="Mobile Number"
                                    fullWidth
                                />
                                <Controller
                                    control={control}
                                    name="subject"
                                    render={({ field: { onChange } }) => (
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <TimePicker
                                                label="Basic example"
                                                renderInput={(params) => console.log(params)}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </InputWrapper> */}

                                    <InputWrapper>
                                        <AssignmentInputButtonContainer >
                                            <Input value={imageUploadValue} fullWidth type='text' placeholder="Choose file" style={{ height: '42px' }} />
                                            <label htmlFor="contained-button-file">
                                                <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                                <UploadButton variant="contained" component="span"
                                                    disableElevation
                                                    color="primary"
                                                >
                                                    BROWSE
                                                </UploadButton>
                                            </label>
                                        </AssignmentInputButtonContainer>
                                    </InputWrapper>
                                </div>
                                <FormAction>
                                    <Button
                                        style={{
                                            backgroundColor: '#FF348E'
                                        }}
                                        type="submit"
                                    >
                                        ADD to deploy queue
                                    </Button>
                                    <Hr />
                                    <Button
                                        variant="link"
                                        style={{
                                            color: '#000000',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Save Draft
                                    </Button>
                                    <Hr />
                                    <Button
                                        variant="link"
                                        style={{
                                            color: '#FF348E'
                                        }}
                                    >
                                        DELETE EXAM
                                    </Button>
                                </FormAction>
                            </FormGrid>


                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default ExaminationCreate
